import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { media } from '../themes/theme';
const Wrapper = styled.section `
  color: ${props => props.theme.Gray};
  font-family: ${props => props.theme.fonts.serif};

  font-size: 0.875rem;
  ${media.laptop `
    font-size: 1rem;
  `};
`;
const AlternatingColorList = styled.ol `
  list-style-position: inside;
`;
const Track = styled.li `
  border-radius: 0.5rem;
  counter-increment: track-counter;
  padding: 0.25rem 0.5rem;
  font-weight: 300;
  word-break: break-all;
  font-size: 0.875rem;

  &:nth-child(even) {
    background: ${props => props.theme.GrayLightest};
  }

  > div {
    display: grid;
    grid-template-columns: 1.8rem 1fr 2.4rem;
    word-break: break-word;
    span:last-child {
      text-align: right;
    }
  }

  ${media.tablet `
    font-size: 1rem;
    > div {
      grid-template-columns: 2.1rem 1fr 2.7rem;
    }
  `}
`;
const Title = styled.h2 `
  font-weight: bold;
  line-height: 1.29;
  margin-bottom: 0.5rem;
  ${media.tablet `
    margin-bottom: 1rem;
  `}
`;
export const TrackList = ({ className = undefined, tracks, }) => {
    const { t } = useTranslation();
    return (React.createElement(Wrapper, { className: className, "data-testid": "track-list" },
        React.createElement(Title, null, t('TrackList:Title')),
        React.createElement(AlternatingColorList, null, tracks.map((track, index) => {
            const trackNumber = `${index < 9 ? '0' : ''}${index + 1} - `;
            return (React.createElement(Track, { "data-testid": "track-list-track", key: index }, typeof track === 'string' ? (trackNumber + track) : (React.createElement("div", null,
                React.createElement("span", null, trackNumber),
                React.createElement("span", null, track.title),
                React.createElement("span", null, track.duration)))));
        }))));
};
